import type { ReactNode } from 'react';
import ReactDOM from 'react-dom';

import { rootElementId } from '#@/shared/constants';

export interface PortalProps {
  children: ReactNode;
}

const Portal: React.FC<PortalProps> = ({ children }) =>
  // We know that rootElementId is always going to exist
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  ReactDOM.createPortal(children, document.getElementById(rootElementId)!);

export default Portal;
